import React, { useState, useEffect } from 'react';
import { Form, Button, Progress, Popup } from 'semantic-ui-react';
import ContactInput from '../../components/ContactInput';

import './style.less';

interface Props {
    firstName: string;
    lastName: string;
    error: string;
    disabledButton: boolean;
    code?: string;
    showCodeInput?: boolean;
    contact?: string;
    contactDisabled?: boolean;

    setFirstName: (e) => any;
    setLastName: (e) => any;
    setCode: (e) => any;
    handleSignUpSubmit: (e, contact, password) => any;
}

const SignUpComponent: React.FC<Props> = (props) => {
    const [contact, setContact] = useState<string>(props.contact ? props.contact : '');
    const [password, setPassword] = useState<string>('');
    const [defaultContactType, setDefaultContactType] = useState('');
    const [isContactDisabled, setIsContactDisabled] = useState(props.contactDisabled ? true : false);
    const [usernameError, setUsernameError] = useState('');
    const getContactType = (contact) => {
        const testExp = new RegExp(/\@/);

        return testExp.test(contact) ? 'email' : 'phone';
    };

    // Refactor for repeats when you can breathe!

    const isUsernameValid = (contact) => {
        const emailRegExp = new RegExp(/\S+@\S+\.\S+/g);
        const e164RegExp = new RegExp(/^\+[1-9]\d{1,14}$/g);

        const isEmailValid = emailRegExp.test(contact);
        const isNumberValid = e164RegExp.test(contact);

        return isEmailValid || isNumberValid;
    };

    return (
        <Form
            error
            autoComplete="off"
            onSubmit={(e) => {
                if (isUsernameValid(contact.toLowerCase())) {
                    props.handleSignUpSubmit(e, contact.toLowerCase(), password);
                } else {
                    setUsernameError('Email or Phone number not valid');
                }
            }}
        >
            {props.error && (
                <Form.Field>
                    <div className="error-message">{props.error}</div>
                </Form.Field>
            )}
            {/* <Form.Field>
                <Form.Input
                    value={props.receivedContact ? props.receivedContact : contact}
                    type="text"
                    name="contact"
                    placeholder="email or phone number"
                    required
                    autoComplete="false"
                    onChange={e => setContact(e.currentTarget.value)}
                />
            </Form.Field> */}

            <Form.Field>
                <Popup
                    content="We have filled in your code for you"
                    open
                    disabled={!props.code}
                    position='left center'
                    trigger={
                        <Form.Input
                            value={props.code}
                            type="text"
                            name="new-code"
                            // placeholder="Code (if you have been provided a code)"
                            placeholder={
                                process.env.REACT_APP_PLATFORM === 'community'
                                ?   'Signup Code'
                                : 'Code (if you have been provided a code)'
                            }
                            autoComplete="false"
                            onChange={(e) => props.setCode(e.currentTarget.value)}
                            disabled={!!props.code}
                        />
                    }
                />
            </Form.Field>

            <ContactInput
                contact={contact}
                onChange={(e) => {
                    console.log(e, 'eee');
                    setUsernameError('');
                    setContact(e);
                }}
                isDisabled={isContactDisabled}
                error={usernameError}
            />

            <Form.Field>
                <Form.Input
                    value={props.firstName}
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    required
                    autoComplete="false"
                    onChange={(e) => props.setFirstName(e.currentTarget.value)}
                />
            </Form.Field>

            <Form.Field>
                <Form.Input
                    value={props.lastName}
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    required
                    autoComplete="false"
                    onChange={(e) => props.setLastName(e.currentTarget.value)}
                />
            </Form.Field>

            <Form.Field className="invite-container ml-8 ">
                <Form.Input
                    value={password}
                    type="password"
                    name="password"
                    className={password ? 'full-75' : 'full-width'}
                    placeholder="Create Password"
                    required
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.currentTarget.value)}
                />
                {password && (
                    <Progress
                        percent={(password.length / 8) * 100}
                        size="tiny"
                        autoSuccess
                        color="red"
                        style={{ width: '25%', marginBottom: '0px' }}
                    />
                )}
            </Form.Field>

            <Button disabled={!props.firstName || !props.lastName || !password} type="submit" primary>
                Register
            </Button>
        </Form>
    );
};

export default SignUpComponent;
